import { render, staticRenderFns } from "./Mouth13.vue?vue&type=template&id=9e864202&"
import script from "./Mouth13.vue?vue&type=script&lang=js&"
export * from "./Mouth13.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports